export default __webpack_public_path__ + "static/media/Matthews Intelligent Identification.5b7e40b4.png";